
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tennis/city/[citySlug]/lessons",
      function () {
        return require("private-next-pages/tennis/city/[citySlug]/lessons/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tennis/city/[citySlug]/lessons"])
      });
    }
  